import React, { Component } from 'react'
import { Row, Col, Divider, Tabs, Input, Select, Button, Table, Modal, Spin, message } from 'antd'
import {ajaxApi, fileDownloadApiNew, getMethod, submitMethod} from '@/server'
import common from '../../public/common'
import './index.less'
import { getParmUrl, getCookie } from '../../public/utils'
import moment from 'moment'
const { TextArea } = Input
const { TabPane } = Tabs
const { Option } = Select
class ReportDetails extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            spin: false,
            visible: false,
            search: {},
            infoData: {},
            handleArr: [],
            batchData: [],
            productData: [],
            imgUrl: '',
            tabType: '1'
        }
    }
    componentDidMount() {
        this.getDetails()
        this.getBatchList()
        this.getHandle()
    }
    // 获取发货详情基本信息
    getDetails = () => {
        this.setState({
            spin: true
        })
        ajaxApi({
            url: common.SapUrl + '/difference/supplier/report/detail',
            params: {
                sid: getCookie('userName'),
                id: getParmUrl('id')
            }
        }).then(res => {
            if (res.data) {
                this.setState({
                    spin: false,
                    infoData: res.data
                })
            }
        })
    }
    // 获取供应商批次维度信息
    getBatchList = async() => {
        const res = await ajaxApi({
            url: common.SapUrl + '/difference/supplier/report/batch/detail',
            params: {
                different: this.state.search.different,
                product: this.state.search.product,
                sid: getCookie('userName'),
                id: getParmUrl('id')
            }
        })
        if (res) {
            this.setState({
                batchData: res.data.difference_report_batch_details
            })
        }
    }
    // 获取供应商货品维度信息
    getProductList = async() => {
        const res = await ajaxApi({
            url: common.SapUrl + '/difference/supplier/report/product/detail',
            params: {
                different: this.state.search.different,
                product: this.state.search.product,
                deal_way_id: this.state.search.deal_way_id,
                sid: getCookie('userName'),
                id: getParmUrl('id')
            }
        })
        if (res) {
            this.setState({
                productData: res.data.difference_report_product_details
            })
        }
    } // 获取处理方式
    getHandle = async() => {
        const res = await ajaxApi({
            url: common.SapUrl + '/difference/report/dealways',
            params: {}
        })
        if (res) {
            this.setState({
                handleArr: res.data
            })
        }
    }
    searchSelect = (name, val) => {
        let _search = this.state.search
        _search[name] = val
        this.setState({
            search: _search
        })
     }
    searchInput = (e) => {
         let _search = this.state.search
         _search.product = e.target.value
         this.setState({
             search: _search
         })
    }
     // 查询维度商品
    search = () => {
         if (this.state.tabType === '1') {
           this.getBatchList()
         } else {
           this.getProductList()
         }
    }
    // 切换维度
    searchTab = (val) => {
        if (val === '1') {
          this.setState({
              tabType: '1'
          }, () => {
              this.getBatchList()
          })
        } else {
          this.setState({
              tabType: '2'
          }, () => {
              this.getProductList()
          })
        }
    }
    lagerImg = (url) => {
        this.setState({
            visible: true,
            imgUrl: url,
        })
    }
    handleCancel = () => {
        this.setState({
            visible: false
        })
    }
     // 确认
     handleOk = async() => {
        const res = await ajaxApi({
            url: common.SapUrl + '/difference/report/supplier/confirm',
            params: {
                id: getParmUrl('id'),
                sid: getCookie('userName') 
            }
        })
        if (res.data === null) {
            message.success('确认成功！')
            this.getDetails()
        }
     }
    // 打印
    print = () => {
        this.props.history.push('/main/differReport/reportPrint?id='+getParmUrl('id'))
    }
    import = () => {
        fileDownloadApiNew({
            url: common.SapUrl + '/difference/supplier/reports/excel',
            param: {
                sid: getCookie('userName'),
                id: getParmUrl('id'),
                ...this.state.search
            },
            filename: '发货单明细'+moment(new Date()).format('YYYYMMDDHHmmss')+'.xlsx'
        })
    }
    render() {
        const { spin, visible, infoData, handleArr, batchData, productData } = this.state
        const columnsBatch = [
            {
                title: '是否差异',
                align: 'center',
                dataIndex: 'different',
                render: (text) => (
                    <span>{text === true ? '有' : '无'}</span>
                )
            },
            {
                title: '货品编码',
                align: 'center',
                dataIndex: 'product_code'
            },
            {
                title: '货品名称',
                align: 'center',
                dataIndex: 'product_name'
            },
            {
                title: '批号',
                align: 'center',
                dataIndex: 'batch_number'
            },
            {
                title: '生产日期',
                align: 'center',
                dataIndex: 'producation_date'
            },
            {
                title: '失效日期',
                align: 'center',
                dataIndex: 'expiry_date'
            },
            {
                title: '供应商发货',
                align: 'center',
                dataIndex: 'delivery_code'
            },
            {
                title: '收货-合格',
                align: 'center',
                dataIndex: 'qualified_number'
            },
            {
                title: '收货-不合格',
                align: 'center',
                dataIndex: 'unqualified_number'
            },
            {
                title: '图片',
                align: 'center',
                dataIndex: 'images',
                render: (text) => (
                    <div>
                        {text.map(item => {
                            return  <img src={item.imageurl} style={{width: '30px;', height: '30px', cursor: 'pointer'}} onClick={this.lagerImg.bind(this, item.imageurl)}/>
                        })}
                    </div>
                )
            }
        ]
        const columnsGood = [
            {
                title: '是否差异',
                align: 'center',
                dataIndex: 'different',
                render: (text) => (
                    <span>{text === true ? '有' : '无'}</span>
                )
            },
            {
                title: '货品编码',
                align: 'center',
                dataIndex: 'product_code'
            },
            {
                title: '货品名称',
                align: 'center',
                dataIndex: 'product_name'
            },
            {
                title: '采购',
                align: 'center',
                dataIndex: 'po_number'
            },
            {
                title: '供应商发货',
                align: 'center',
                dataIndex: 'delivery_number'
            },
            {
                title: '仓库验货-合格',
                align: 'center',
                dataIndex: 'qualified_number'
            },
            {
                title: '仓库验货-不合格',
                align: 'center',
                dataIndex: 'unqualified_number'
            },
            {
                title: '处理方式',
                align: 'center',
                dataIndex: 'deal_way',
            },
            {
                title: '备注',
                align: 'center',
                dataIndex: 'remark'
            }
        ]
        return (<div className="differcen">
            <Spin spinning={spin}>
            <div className="search">
                <h3>基本信息</h3>
                <Row>
                    <Col span={6}>
                        <label>差异单号：</label>
                        <span>{infoData.difference_code}</span>
                    </Col>
                    <Col span={6}>
                        <label>供应商：</label>
                        <span>{infoData.supplier_name}</span>
                    </Col>
                    <Col span={6}>
                        <label>仓库：</label>
                        <span>{infoData.whid_name}</span>
                    </Col>
                </Row>
                <Row style={{marginTop: '10px'}}>
                    <Col span={6}>
                        <label>是否差异：</label>
                        <span>{infoData.different === true ? '有' : '无'}</span>
                    </Col>
                    <Col span={6}>
                        <label>生成时间：</label>
                        <span>{infoData.gmt_create && moment(infoData.gmt_create).format('YYYY-MM-DD HH:mm:ss')}</span>
                    </Col>
                    <Col span={6}>
                        <label>报告人：</label>
                        <span>{infoData.reporter_name}</span>
                    </Col>
                </Row>
                <Divider/>
                <h3>到货信息</h3>
                <Row>
                    {/* <Col span={6}>
                        <label>来货单：</label>
                        <a onClick={this.goLink.bind(this, infoData.delivery_id)}>{infoData.delivery_code}</a>
                    </Col> */}
                    <Col span={6}>
                        <label>发货单：</label>
                        <span>{infoData.supplier_delivery_code}</span>
                    </Col>
                    <Col span={6}>
                        <label>外部单号：</label>
                        <span>{infoData.link_order_number}</span>
                    </Col>
                </Row>
                <Divider/>
                <h3>采购信息</h3>
                {
                    infoData.difference_report_purchaser_details && infoData.difference_report_purchaser_details.map(item => {
                        return  <Row>
                                    {/* <Col span={6}>
                                        <label>采购单：</label>
                                        <a>{item.po_code}</a>
                                    </Col> */}
                                    <Col span={6}>
                                        <label>采购员：</label>
                                        <span>{item.purchaser_name}</span>
                                    </Col>
                                    <Col span={6}>
                                        <label>联系方式：</label>
                                        <span>{infoData.purchaser_phone}</span>
                                    </Col>
                                </Row>
                    })
                }
                <Divider/>
                <h3>退件信息</h3>
                <Row>
                    <Col span={6}>
                        <label>退件地址：</label>
                        <span>{infoData.return_address}</span>
                    </Col>
                    <Col span={6}>
                        <label>退件联系人：</label>
                        <span>{infoData.return_contacts}</span>
                    </Col>
                    <Col span={6}>
                        <label>联系方式：</label>
                        <span>{infoData.return_contacts_phone}</span>
                    </Col>
                </Row>
                <Row style={{marginTop: '10px'}}>
                    <Col span={6}>
                        <label>物流公司：</label>
                        <span>{infoData.return_logistics_name}</span>
                    </Col>
                    <Col span={6}>
                        <label>物流单号：</label>
                        <span>{infoData.return_logistics_numbers}</span>
                    </Col>
                </Row>
                <Row style={{marginTop: '10px', marginBottom: '15px'}}>
                    <Col style={{display: 'inherit'}} span={18}>
                       <label>备注：</label>
                       <TextArea style={{width: '80%'}} value={infoData.remark}/>
                    </Col>
                </Row>
                <h3>差异明细</h3>
                <Divider/>
                <div>
                    <Row>
                        <Col span={6}>
                            <label>货品：</label>
                            <Input style={{width: '70%'}} onSelect={this.searchInput} placeholder="请输入货品(商品)编码、名称"/>
                        </Col>
                        <Col span={4}>
                            <label>是否差异：</label>
                            <Select style={{width: '60%'}} onSelect={this.searchSelect.bind(this, 'different')} placeholder="请选择">
                                <Option value={null}>请选择</Option>
                                <Option value={true}>有</Option>
                                <Option value={false}>无</Option>
                            </Select>
                        </Col>
                        {
                            this.state.tabType === '2' && 
                        <Col span={6}>
                            <label>处理方式：</label>
                            <Select style={{width: '60%'}} onSelect={this.searchSelect.bind(this, 'deal_way_id')}>
                                {
                                    handleArr.map(item => {
                                        return <Option value={item.key} title={item.value} key={item.key}>{item.value}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                        }
                        <Col span={6}>
                            <Button onClick={this.search} shape="round">查询</Button>
                        </Col>
                    </Row>
                </div>
                <Tabs onChange={this.searchTab}>
                    <TabPane tab="批号维度" key="1">
                        <div style={{margin: '10px'}}>
                            <span>汇总：</span>
                            <span>异常货品种类：</span>
                            <span style={{color: '#f00'}}>{infoData.total_abnormal_number}</span>
                            <span style={{marginLeft: '15px'}}>供应商发货：</span>
                            <span style={{color: '#f00'}}>{infoData.total_delivery_number}</span>
                            <span style={{marginLeft: '15px'}}>收货-合格：</span>
                            <span style={{color: '#f00'}}>{infoData.total_qalified_number}</span>
                            <span style={{marginLeft: '15px'}}>收货-不合格：</span>
                            <span style={{color: '#f00'}}>{infoData.total_unqualified_number}</span>
                        </div>
                        <Table columns={columnsBatch} dataSource={batchData} pagination={false}/>
                    </TabPane>
                    <TabPane tab="货品维度" key="2">
                        <div style={{margin: '10px'}}>
                            <p>
                            <Button type='primary' shape="round" onClick={this.import}>导出</Button>
                            </p>
                            <span>汇总：</span>
                            <span>异常货品种类：</span>
                            <span style={{color: '#f00'}}>{infoData.total_abnormal_number}</span>
                            <span style={{marginLeft: '15px'}}>供应商发货：</span>
                            <span style={{color: '#f00'}}>{infoData.total_delivery_number}</span>
                            <span style={{marginLeft: '15px'}}>收货-合格：</span>
                            <span style={{color: '#f00'}}>{infoData.total_qalified_number}</span>
                            <span style={{marginLeft: '15px'}}>收货-不合格：</span>
                            <span style={{color: '#f00'}}>{infoData.total_unqualified_number}</span>
                        </div>
                        <Table columns={columnsGood} dataSource={productData} pagination={false}/>
                    </TabPane>
                </Tabs>
                <p style={{margin: '15px 0'}}>
                    <Button type="primary" shape="round" onClick={this.handleOk}>确认</Button>
                    <Button type="primary" shape="round" style={{marginLeft: '10px'}} onClick={this.print}>打印</Button>
                    <Button shape="round" style={{marginLeft: '10px'}} onClick={() => {this.props.history.go(-1)}}>返回</Button>
                </p>
            </div>
            </Spin>
            <Modal title="图片预览"
            visible={visible}
            onCancel={this.handleCancel}
            footer={[<Button type="primary" shape="round" onClick={this.handleCancel}>确认</Button>]}
            >
                <img src={this.state.imgUrl} style={{width: '470px'}}/>
            </Modal>
        </div>)
    }
}
export default ReportDetails


// WEBPACK FOOTER //
// ./src/pages/differReport/reportDetails.js